import React from 'react';
import {Typography, Grid} from '@mui/material';
import {useAutoField, useLoadedAutoField} from '../../../components/AutoForm/useAutoForm';
import {
  BuilderProps,
  getValidation,
} from '../CreateBuilder/BuilderSourceDestination/builderValidators';
import {
  BuilderColumnWrapper,
  BuilderSourceColumnHeader,
  BuilderDestinationColumnHeader,
} from '../CreateBuilder/BuilderSourceDestination/BuilderSourceDestination';
import {setUpAnnuityFields} from './builderAnnuityFields';
import {BuilderPlanFormsStyled} from '../CreateBuilder/BuilderSourceDestination/BuilderPlanForm';
import {AnnuitySourceParent} from './AnnuitySourceParent';
import {AnnuityDestinationRow} from './AnnuityDestinationRow';
import {useAnnuityPotsQuery} from './useAnnuityPotsQuery';
import {changeAnnuitySourceFactory} from '../hooks/builderAnnuityHooks';

export const BuilderAnnuityPlan: React.FC<BuilderProps> = ({sourceDestinationLabels}) => {
  const [annuityField, annuityMeta, annuityHelpers] = useAutoField<
    setUpAnnuityFields | undefined
  >('annuity');

  const {sourcePots} = useAnnuityPotsQuery();

  const changeSource = changeAnnuitySourceFactory({
    sourcePots,
    annuityHelpers,
    annuityValue: annuityField.value,
  });

  return (
    <BuilderColumnWrapper>
      <Grid item xs={6} xl={5.8} data-test="Source Choices">
        <BuilderSourceColumnHeader
          fromError={annuityMeta.error}
          sourceLabel={sourceDestinationLabels?.first}
        />
        <BuilderPlanFormsStyled>
          {sourcePots.map((pot) => (
            <AnnuitySourceParent
              key={pot.id}
              pot={pot}
              selectedSourceId={annuityField.value?.sourceId}
              handleChange={changeSource}
            />
          ))}
        </BuilderPlanFormsStyled>
      </Grid>
      <Grid item xs={6} xl={5.8} data-test="Destination Choices">
        <BuilderDestinationColumnHeader
          toError={annuityMeta.error}
          destinationLabel={sourceDestinationLabels?.second}
        />
        <AnnuityDestinationRow validation={getValidation(annuityMeta)} />
      </Grid>
    </BuilderColumnWrapper>
  );
};
